// 1. Content Mapper for B2C T36
import { getAssetUrl } from '../../Common/Utils/assetUrl';
export const mapB2CTenantToLanding = (tenantData) => {
  const theme = tenantData?.theme || {};
  const topBar = tenantData?.topBar || {};
  const header = tenantData?.header || {};
  const footer = tenantData?.footer || {};
  const hero = tenantData?.hero || {};

  return {
      isPreview: tenantData?.isPreview ?? false,
    companyId:   tenantData?.companyId,
    branchId:    tenantData?.branchId,
    userId:      tenantData?.userId,
    logoUrl: getAssetUrl(tenantData?.branding?.logoUrl) || '/assets/images/logo.png',
    companyName: tenantData?.branding?.companyName || 'Travel Agency',
    brandName:   tenantData?.branding?.brandName   || 'Travel Agency',

    email:    tenantData?.branding?.email    || 'info@travelagency.com',
    phones:   tenantData?.branding?.phones   || '9000000000',
    whatsapp: tenantData?.branding?.whatsapp || '9000000000',
    socials:  tenantData?.branding?.socials  || {},

     companyData:     tenantData?.companyData || {},
     seo: tenantData?.seo || {},

     aboutUs: tenantData?.aboutUs || {},
     contactUs: tenantData?.contactUs || {},
    faq: tenantData?.faq || {},
    terms: tenantData?.terms || {},
    privacyPolicy: tenantData?.privacyPolicy || {},
      refundPolicy: tenantData?.refundPolicy || {},
    themeColor1: theme.themeColor1 || theme.themecolor1,
    themeColor2: theme.themeColor2 || theme.themecolor2,
    themeColor3: theme.themeColor3 || theme.themecolor3,
    themeColor4: theme.themeColor4 || theme.themecolor4,
    themeColor5: theme.themeColor5 || theme.themecolor5,

    topBarBg:   topBar.bgColor  || theme.themeColor2 || theme.themecolor2 || '#06172B',
    topBarText: topBar.textColor || '#ffffff',
    headerBg:   header.bgColor  || '#ffffff',
    headerText: header.textColor || '#1a1a2e',
    footerBg:   footer.bgColor  || theme.themeColor2 || theme.themecolor2 || '#06172B',
    footerText: footer.textColor || '#ffffff',

    headingFont: tenantData?.branding?.headingFont || 'Poppins',
    bodyFont:    tenantData?.branding?.bodyFont    || 'Poppins',

    heroData: {
      flights: {
        title:     hero.flights?.title    || 'Search & Book Flights',
        subTitle:  hero.flights?.subTitle || 'Millions of cheap flights. One simple search.',
        textColor: hero.flights?.textColor || '#ffffff',
        bgImage:   hero.flights?.bgImage,
      },
      hotels: {
        title:     hero.hotels?.title    || 'Search & Book Hotels',
        subTitle:  hero.hotels?.subTitle || 'Best hotel deals at lowest prices.',
        textColor: hero.hotels?.textColor || '#ffffff',
        bgImage:   hero.hotels?.bgImage,
      },
      holidays: {
        title:     hero.holidays?.title    || 'Explore Holiday Packages',
        subTitle:  hero.holidays?.subTitle || 'Tailor-made holidays for every budget.',
        textColor: hero.holidays?.textColor || '#ffffff',
        bgImage:   hero.holidays?.bgImage,
      },
      sightseeing: {
        title:     hero.sightseeing?.title    || 'Discover Activities',
        subTitle:  hero.sightseeing?.subTitle || 'Experiences you will treasure forever.',
        textColor: hero.sightseeing?.textColor || '#ffffff',
        bgImage:   hero.sightseeing?.bgImage,
      },
    },
  };
};

// 2. Color Resolver for B2C T36
export const getB2CColors_T36 = (landingData) => {
  const c1 = landingData.themeColor1 || '#1a3c72';
  return {
    theme1:     c1,
    theme2:     landingData.footerBg   || '#06172B',
    theme3:     landingData.headerBg   || '#ffffff',
    theme4:     landingData.themeColor4 || '#F2F6FF',
    theme5:     landingData.themeColor5 || '#ffffff',
    headerText: landingData.headerText || '#1a1a2e',
    footerText: landingData.footerText || '#ffffff',
    topBarBg:   landingData.topBarBg   || '#06172B',
    topBarText: landingData.topBarText || '#ffffff',
  };
};
